export const lmwAuthLazyLoadedState = {
  path: 'user'
};